var _style, _g, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCbiLogos01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 792 279.8",
    style: {
      enableBackground: "new 0 0 792 279.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ED184B;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#FFD100;}\r\n\t.st3{fill:#F05023;}\r\n\t.st4{fill:url(#SVGID_1_);}\r\n\t.st5{fill:url(#SVGID_00000114789944956047121930000003244518045468493193_);}\r\n\t.st6{fill:url(#SVGID_00000115493024212967525320000002166559289079629975_);}\r\n\t.st7{fill:url(#SVGID_00000033369894502478706780000000911873101455568828_);}\r\n\t.st8{fill:#231F20;}\r\n\t.st9{fill:url(#SVGID_00000135669619492230783270000014486027988336818861_);}\r\n\t.st10{fill:url(#SVGID_00000104668522049932663520000015608133939730626222_);}\r\n\t.st11{fill:url(#SVGID_00000098191098833636090770000003796527982831826053_);}\r\n\t.st12{fill:url(#SVGID_00000072969154029653924670000012968676002883668405_);}\r\n\t.st13{fill:url(#SVGID_00000094603113507110540470000005435286675979920292_);}\r\n\t.st14{fill:url(#SVGID_00000135680474285275436550000000668630445845700010_);}\r\n\t.st15{fill:url(#SVGID_00000150786561666841958830000015456615339828988037_);}\r\n\t.st16{fill:url(#SVGID_00000011719451653107804130000012643489131794911121_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M305,84c0-14.1,10.7-23.7,24.4-23.7c10.1,0,16,5.5,19.2,11.2l-8.4,4.1c-1.9-3.7-6.1-6.7-10.8-6.7 c-8.3,0-14.4,6.4-14.4,15.1c0,8.7,6.1,15.1,14.4,15.1c4.7,0,8.9-2.9,10.8-6.7l8.4,4.1c-3.3,5.7-9.1,11.3-19.2,11.3 C315.7,107.7,305,98.1,305,84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M354.5,106.9V61h32.5v8.6h-22.7v9.7h22.2v8.6h-22.2v10.4h22.7v8.6H354.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M426.2,106.9L404.3,77v29.9h-9.8V61h10l21.3,28.8V61h9.8v45.9H426.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M455.3,106.9V69.6h-13.4V61h36.6v8.6h-13.3v37.3H455.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M484.7,106.9V61h32.5v8.6h-22.7v9.7h22.2v8.6h-22.2v10.4h22.7v8.6H484.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M550.8,106.9l-9-16.3h-7.2v16.3h-9.8V61h21.5c9.6,0,15.4,6.3,15.4,14.8c0,8.1-5.1,12.5-10,13.6l10.3,17.5 H550.8z M551.7,75.8c0-3.9-3-6.2-6.9-6.2h-10.2V82h10.2C548.8,82,551.7,79.7,551.7,75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M586.7,106.9V61h32.5v8.6h-22.7v9.7h22.2v8.6h-22.2v19H586.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M623.7,84c0-13.8,10.1-23.7,23.9-23.7c13.9,0,24,9.9,24,23.7s-10.1,23.7-24,23.7 C633.9,107.7,623.7,97.8,623.7,84z M661.7,84c0-8.6-5.5-15.1-14-15.1c-8.5,0-13.9,6.5-13.9,15.1c0,8.5,5.4,15.1,13.9,15.1 C656.2,99.1,661.7,92.5,661.7,84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M704.5,106.9l-9-16.3h-7.2v16.3h-9.8V61H700c9.6,0,15.4,6.3,15.4,14.8c0,8.1-5.1,12.5-10,13.6l10.3,17.5 H704.5z M705.5,75.8c0-3.9-3-6.2-6.9-6.2h-10.3V82h10.3C702.5,82,705.5,79.7,705.5,75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M307.2,165.6v-45.9h24.1c8.7,0,13.2,5.6,13.2,11.7c0,5.8-3.6,9.6-7.9,10.5c4.9,0.8,8.8,5.5,8.8,11.3 c0,6.9-4.6,12.4-13.3,12.4H307.2z M334.6,133.2c0-2.9-2.1-5-5.4-5H317v10h12.2C332.5,138.1,334.6,136,334.6,133.2z M335.5,151.9 c0-2.9-2.1-5.4-5.9-5.4H317v10.7h12.6C333.3,157.2,335.5,155.2,335.5,151.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M352.8,147.3v-27.6h9.9V147c0,6.4,3.7,10.8,10.8,10.8c7.1,0,10.7-4.4,10.7-10.8v-27.2h10v27.5 c0,11.4-6.7,19.2-20.7,19.2C359.6,166.5,352.8,158.6,352.8,147.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M400.1,159.2l5.3-7.4c3.2,3.4,8.3,6.2,14.6,6.2c5.4,0,8-2.5,8-5.1c0-8.1-26.4-2.5-26.4-19.8 c0-7.6,6.6-14,17.4-14c7.3,0,13.3,2.2,17.9,6.4l-5.4,7.2c-3.7-3.4-8.7-5-13.3-5c-4.2,0-6.5,1.9-6.5,4.6c0,7.3,26.3,2.4,26.3,19.5 c0,8.4-6,14.7-18.4,14.7C410.7,166.5,404.4,163.5,400.1,159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M444.5,165.6v-45.9h9.8v45.9H444.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M495,165.6l-21.9-29.9v29.9h-9.8v-45.9h10l21.3,28.8v-28.8h9.8v45.9H495z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M513.5,165.6v-45.9H546v8.6h-22.7v9.7h22.2v8.6h-22.2V157H546v8.6H513.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M550.5,159.2l5.3-7.4c3.2,3.4,8.3,6.2,14.6,6.2c5.4,0,8-2.5,8-5.1c0-8.1-26.4-2.5-26.4-19.8 c0-7.6,6.6-14,17.4-14c7.3,0,13.3,2.2,17.9,6.4l-5.4,7.2c-3.7-3.4-8.7-5-13.3-5c-4.2,0-6.5,1.9-6.5,4.6c0,7.3,26.3,2.4,26.3,19.5 c0,8.4-6,14.7-18.4,14.7C561.1,166.5,554.8,163.5,550.5,159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M591.8,159.2l5.3-7.4c3.2,3.4,8.3,6.2,14.6,6.2c5.4,0,8-2.5,8-5.1c0-8.1-26.4-2.5-26.4-19.8 c0-7.6,6.6-14,17.4-14c7.3,0,13.3,2.2,17.9,6.4l-5.4,7.2c-3.7-3.4-8.7-5-13.3-5c-4.2,0-6.5,1.9-6.5,4.6c0,7.3,26.3,2.4,26.3,19.5 c0,8.4-6,14.7-18.4,14.7C602.4,166.5,596,163.5,591.8,159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M681.9,165.6c-1-0.9-2.1-2.1-3.4-3.4c-3.4,2.6-7.6,4.3-12.5,4.3c-8.4,0-15.1-4.4-15.1-13.3 c0-6.9,4.6-10.6,9.8-13.2c-1.8-3.4-3-6.8-3-9.9c0-6.2,5.5-11,13.1-11c6.5,0,12,3.6,12,9.7c0,7-5.6,10-11.3,12.6 c1.4,1.9,2.8,3.6,4,5c1.3,1.7,2.6,3.2,3.9,4.7c1.9-3,3.4-6.2,4.2-8.9l7,3.2c-1.7,3.6-3.8,7.6-6.4,11.1c2.8,3,5.6,6,8.9,9.2H681.9z  M673.8,157.2c-2.1-2.3-4-4.5-5.1-5.8c-1.5-1.9-3.1-3.9-4.6-6.1c-2.4,1.7-4,3.9-4,7c0,4.5,3.3,7.2,7.1,7.2 C669.6,159.6,671.8,158.7,673.8,157.2z M668.4,136.5c3.9-1.9,6.9-3.9,6.9-7.2c0-2.4-1.8-3.9-4.1-3.9c-2.7,0-4.8,2.1-4.8,4.9 C666.4,132.1,667.2,134.3,668.4,136.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M307.2,224.4v-45.9h9.8v45.9H307.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M357.7,224.4l-21.9-29.9v29.9h-9.8v-45.9h10l21.3,28.8v-28.8h9.8v45.9H357.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M407.9,224.4L386,194.4v29.9h-9.8v-45.9h10l21.3,28.8v-28.8h9.8v45.9H407.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M424.1,201.5c0-13.8,10.1-23.7,23.9-23.7c13.9,0,24,9.9,24,23.7c0,13.8-10.1,23.7-24,23.7 C434.3,225.2,424.1,215.3,424.1,201.5z M462.1,201.5c0-8.6-5.5-15.1-14-15.1c-8.5,0-13.9,6.5-13.9,15.1c0,8.5,5.4,15.1,13.9,15.1 C456.5,216.5,462.1,210,462.1,201.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M490.5,224.4l-17.7-45.9h11.1l12.7,35.3l12.7-35.3h11.1l-17.7,45.9H490.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M553.1,224.4l-2.8-7.8h-19.7l-2.9,7.8h-11.1l17.7-45.9h12.2l17.7,45.9H553.1z M540.4,188.2l-7.2,19.7h14.3 L540.4,188.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M574.6,224.4v-37.3h-13.4v-8.6h36.6v8.6h-13.3v37.3H574.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M604.1,224.4v-45.9h9.8v45.9H604.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M620.7,201.5c0-13.8,10.1-23.7,23.9-23.7c13.9,0,24,9.9,24,23.7c0,13.8-10.1,23.7-24,23.7 C630.8,225.2,620.7,215.3,620.7,201.5z M658.6,201.5c0-8.6-5.5-15.1-14-15.1c-8.5,0-13.9,6.5-13.9,15.1c0,8.5,5.4,15.1,13.9,15.1 C653.1,216.5,658.6,210,658.6,201.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M707.2,224.4l-21.9-29.9v29.9h-9.8v-45.9h10l21.3,28.8v-28.8h9.8v45.9H707.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.4417,
    y1: 156.5851,
    x2: 232.1144,
    y2: 156.5851
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ED0D6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF4725"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "232.1,135.8 223.8,144.1 215.5,152.4 190.7,177.3 182.4,185.6 174.1,193.9 149.2,218.8 99.4,169  107.7,160.7 116,152.4 124.3,160.7 132.6,169 140.9,177.3 149.2,185.6 157.5,177.3 165.8,169 174.1,160.7 198.9,135.8  190.7,127.6 182.4,135.8 174.1,144.1 165.8,152.4 157.5,160.7 149.2,169 140.9,160.7 132.6,152.4 140.9,144.2 149.2,135.9  174.1,111 182.4,102.7 190.7,94.4 199,102.7 207.2,111 215.5,119.3 223.8,127.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085213909055853667080000015235054941765793929_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.4897,
    y1: 206.3363,
    x2: 232.1144,
    y2: 206.3363
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ED0D6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF4725"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000085213909055853667080000015235054941765793929_)"
    },
    points: "232.1,185.6 215.5,202.2  207.2,210.5 198.9,218.8 174.1,243.7 165.8,235.4 157.5,227.1 165.8,218.8 182.4,202.2 190.7,193.9 198.9,185.6 207.2,177.3  215.5,169 223.8,177.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139287567173905026870000016876734687933735094_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.8218,
    y1: 160.7272,
    x2: 256.9921,
    y2: 160.7272
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ED0D6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF4725"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000139287567173905026870000016876734687933735094_)"
    },
    points: "257,160.7 248.7,169  240.4,177.3 223.8,160.7 232.1,152.4 240.4,144.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031190010477347333030000006736947608389349514_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.5641,
    y1: 98.5372,
    x2: 281.8698,
    y2: 98.5372
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ED0D6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF4725"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000031190010477347333030000006736947608389349514_)"
    },
    points: "281.9,135.8 265.3,152.4  257,144.1 248.7,135.8 240.4,127.6 232.1,119.3 223.8,111 215.5,102.7 207.2,94.4 199,86.1 190.7,77.8 182.4,69.5 174.1,77.8  165.8,86.1 157.5,94.4 149.2,102.7 140.9,111 132.6,119.3 124.3,127.6 116,135.8 107.7,144.1 99.4,152.4 91.1,160.7 74.6,144.1  82.9,135.8 99.4,119.3 107.7,111 165.8,52.9 174.1,44.6 182.4,36.3 190.7,44.6 198.9,52.9 223.8,77.8 232.1,86.1 240.4,94.4  248.7,102.7 257,111  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbiLogos01);
export default __webpack_public_path__ + "static/media/CBI Logos-01.46ac347559f894afea9a20f75c675b7f.svg";
export { ForwardRef as ReactComponent };